module.exports = "/_next/static/images/ai-96e24e9ea6a063bdccddd095adc12265.svg";